import { render } from "./Bus.vue?vue&type=template&id=499fcc56&scoped=true"
import script from "./Bus.vue?vue&type=script&lang=js"
export * from "./Bus.vue?vue&type=script&lang=js"

import "./Bus.vue?vue&type=style&index=0&id=499fcc56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499fcc56"]])

export default __exports__